export default "__VITE_ASSET__9bcdbb16__"